exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-coming-soon[data-v-42874265]{background:#fff;border-radius:250px;width:333px;text-align:center;height:333px;margin:20px auto 50px;padding:115px 0}.block-coming-soon .coming-soon-title[data-v-42874265]{color:var(--key-color);font-style:normal;font-weight:600;font-size:40px;line-height:40px}.block-coming-soon .coming-soon-desc[data-v-42874265]{font-style:normal;font-weight:600;font-size:14px;line-height:24px;padding:0 30px;color:#32373f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42874265","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/Products/houen/partials/BlockComingSoon.vue
// module id = IoBu
// module chunks = 0